module.exports = __webpack_public_path__ + "img/edit_event_step1_on.da8c77a3.png";